import { useEffect } from "react";
import ReactGA from "react-ga";
import { withRouter } from "react-router";

function sendPageView(location) {
  ReactGA.set({ page: location.pathname });

  setTimeout(() => {
    ReactGA.pageview(location.pathname);
  }, 1000);
}

function GAListener({ children, trackingId, history }) {
  useEffect(() => {
    ReactGA.initialize(trackingId);
    sendPageView(history.location);

    return history.listen(sendPageView);
  }, [history, trackingId]);

  return children;
}

export default withRouter(GAListener);
